// Server-safe ImageItem shim
// This replaces the client-side ImageItem component for server components

export default function ImageItem({
  source,
  centered,
  alt,
  title,
  height,
  width,
  className,
  ...props
}) {
  const classes = [
    "ui",
    centered && "centered",
    "image",
    className
  ].filter(Boolean).join(" ");

  return (
    <img
      src={source}
      alt={alt}
      title={title}
      height={height}
      width={width}
      className={classes}
      {...props}
    />
  );
}
